var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Archive = function Archive(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M10 11a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 6c0 1.306.835 2.417 2 2.83V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.83A3.001 3.001 0 0 0 19 3H5a3 3 0 0 0-3 3Zm3-1a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5Zm13 13V9H6v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Archive;